module.exports = __webpack_public_path__ + "static/media/no_image.b957d176.png";